import React from 'react'
import { useExpandToggle } from '@mobi/utils/hooks/useExpandToggle'

export const AnimatedHeightDisplay: React.FC<{ hasItems: boolean; children: React.ReactNode }> = ({
  hasItems,
  children,
}) => {
  const [shouldStartExpanded] = React.useState(hasItems)

  const { toggleExpanded, isExpanded, shouldRender, wrapperRef, contentRef } = useExpandToggle({
    timeoutMs: 360,
    shouldStartExpanded: hasItems,
  })

  React.useLayoutEffect(() => {
    if (!shouldStartExpanded || !wrapperRef.current) return
    wrapperRef.current.style.height = 'auto'
    wrapperRef.current.style.opacity = '1'
  }, [shouldStartExpanded, wrapperRef])

  React.useEffect(() => {
    if (!isExpanded && hasItems) {
      toggleExpanded(true)
    } else if (isExpanded && !hasItems) {
      toggleExpanded(false)
    }
  }, [isExpanded, hasItems, toggleExpanded])

  return shouldRender || isExpanded ? (
    <div
      style={{
        height: 0,
        overflow: 'hidden',
        transition: 'height 360ms cubic-bezier(0.44, 0.1, 0.27, 0.98), opacity 260ms ease',
        opacity: isExpanded ? 1 : 0,
      }}
      ref={wrapperRef}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  ) : null
}
